import { Grid } from '@mui/material';
import React from 'react';
import { DashboardCard } from '../DashboardCard/DashboardCard';
import { ICommonClient, getClientsPaginated } from '../../services/client.service';
import { toast } from 'react-toastify';
import { ClientStatus } from '../../utils/clientStatus';
import { UserRolesEnum } from '../../utils/rolesEnum';
import { useNavigate } from 'react-router-dom';
import { adminTypeEnum } from '../../utils/adminTypes';

interface IProspectiveClientsDashboardCardProps {
  userRole: string;
  adminType: string;
}

export default function ProspectiveClientsDashboardCard(props: IProspectiveClientsDashboardCardProps) {
  const { adminType, userRole } = props;
  const navigate = useNavigate();
  const [prospectiveClients, setProspectiveClients] = React.useState<ICommonClient[]>([]);
  const [lastDoc, setLastDoc] = React.useState<any>(null);
  const [hasMore, setHasMore] = React.useState(true);
  const [isInitialLoading, setIsInitialLoading] = React.useState(true);
  const [isPaginating, setIsPaginating] = React.useState(false);

  const checkCardPermission =
    userRole === UserRolesEnum.SUPER_ADMIN ||
    (userRole === UserRolesEnum.ADMIN && !(adminType === adminTypeEnum.EMPLOYMENT));

  const loadMoreClients = async (isFirstLoad = false) => {
    if (!hasMore) return;
    if (isFirstLoad) setIsInitialLoading(true);
    else setIsPaginating(true);

    try {
      const { clients, lastDoc: newLastDoc } = await getClientsPaginated(ClientStatus.PROSPECTIVE, 10, lastDoc);
      setProspectiveClients((prev) => [...prev, ...clients]);
      setLastDoc(newLastDoc);
      if (!newLastDoc || clients.length < 10) setHasMore(false);
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      if (isFirstLoad) setIsInitialLoading(false);
      else setIsPaginating(false);
    }
  };

  React.useEffect(
    () => {
      if (checkCardPermission) loadMoreClients(true);
    },
    // eslint-disable-next-line
    [userRole]
  );

  const handleScroll = (e: any) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore) {
      loadMoreClients();
    }
  };

  return checkCardPermission ? (
    <Grid item lg={6} xs={12}>
      <DashboardCard
        isLoading={isInitialLoading}
        label='Prospective Clients'
        desc='List of prospective clients'
        list={prospectiveClients}
        onItemClick={(item: any) => {
          navigate('../prospective-client-info', { state: { clientId: item.id } });
        }}
        onScroll={handleScroll}
        height='376px'
        showBottomLoader={isPaginating}
      />
    </Grid>
  ) : null;
}
